import { render, staticRenderFns } from "./FormClone.vue?vue&type=template&id=6dec758a"
import script from "./FormClone.vue?vue&type=script&lang=js"
export * from "./FormClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports